import * as ActionTypes from './index';
import { actionCreator } from '../helpers/functions';

export const getBrands = actionCreator(ActionTypes.GET_BRANDS);
export const getBrandsSuccess = actionCreator(ActionTypes.GET_BRANDS_SUCCESS);
export const getBrandsFailed = actionCreator(ActionTypes.GET_BRANDS_FAILED);
export const countBrands = actionCreator(ActionTypes.COUNT_BRANDS);
export const countBrandsSuccess = actionCreator(ActionTypes.COUNT_BRANDS_SUCCESS);
export const countBrandsFailed = actionCreator(ActionTypes.COUNT_BRANDS_FAILED);
export const createBrand = actionCreator(ActionTypes.CREATE_BRAND);
export const createBrandSuccess = actionCreator(ActionTypes.CREATE_BRAND_SUCCESS);
export const createBrandFailed = actionCreator(ActionTypes.CREATE_BRAND_FAILED);
export const storeTemporaryBrandImage = actionCreator(ActionTypes.STORE_TEMPORARY_BRAND_IMAGE);
export const clearBrandForm = actionCreator(ActionTypes.CLEAR_BRAND_FORM);
export const clearTempUploadedProductBrand = actionCreator(ActionTypes.CLEAR_TEMP_UPLOADED_PRODUCT_BRAND);
export const deleteBrand = actionCreator(ActionTypes.DELETE_BRAND);
export const deleteBrandSuccess = actionCreator(ActionTypes.DELETE_BRAND_SUCCESS);
export const deleteBrandFailed = actionCreator(ActionTypes.DELETE_BRAND_FAILED);
export const changeBrandPreferences = actionCreator(ActionTypes.CHANGE_BRANDS_PREFERENCES);
export const changeBrandsOrder = actionCreator(ActionTypes.CHANGE_BRANDS_ORDER);
export const clearBrandDeleteErrorMessage = actionCreator(ActionTypes.CLEAR_BRAND_DELETE_ERROR_MESSAGE);
export const editBrand = actionCreator(ActionTypes.EDIT_BRAND);
export const editBrandFailed = actionCreator(ActionTypes.EDIT_BRAND_FAILED);
export const editBrandSuccess = actionCreator(ActionTypes.EDIT_BRAND_SUCCESS);
export const editBrandField = actionCreator(ActionTypes.EDIT_BRAND_FIELD);
export const copyBrandForEdit = actionCreator(ActionTypes.COPY_BRAND_FOR_EDIT);


// WEBPACK FOOTER //
// ./src/actions/brands.js